import React, { useState } from 'react';
import setupIcon from '../../assets/icons/setting.png';
import arrowIcon from '../../assets/icons/new-window.svg';
import useComponentVisible from '../UI/ComponentVisible';
import { useUserContext } from '../../contexts/UserContext';
import AdobeIoIntegrationModal from './AdobeIoIntegreationModal/index'
import AdobeTargetWorkspaceModal from './AdobeTargetWorkspaceModal/index'
import TealiumIntegrationModal from './TealiumIntegrationModal'
import { useNavigate } from 'react-router-dom';
import AEMAdobeIOModal from './AEMAdobeIOModal/AEMAdobeIOModal';
import { getIntegrations } from '../../constants/globalSelectorIntegrations';
import ContentfulIntegrationModal from './ContentfulIntegrationModal';
import { useContentfulContext } from '../../contexts/ContentfulContext';
import ViewFoldersModal from './AEMAdobeIOModal/ViewFoldersModal';
import GithubIntegrationModal from './GithubIntegreationModal';

const IntegrationItem = ({ title, type, onViewFolders, folder, item, onModalOpen, add_new_path, label_for_new_record }) => {
    const navigate = useNavigate();
    const { userData } = useUserContext();

    const hasAccess = userData?.selectedOrganization?.level?.route_permission[type];

    const renderItem = () => {
        if (!item) {
            return (
                <p
                    className="block cursor-pointer text-primary"
                    onClick={() => navigate(add_new_path)}
                >
                    {label_for_new_record}
                </p>
            );
        }

        return (
            <>
                <div
                    className="flex flex-col py-1 hover:bg-gray-100 cursor-pointer"
                    onClick={onModalOpen}
                >
                    <div className="flex justify-between items-center">
                        <p className="block break-words">{item}</p>
                        <img src={arrowIcon} alt="arrow" className="w-4 h-4" />
                    </div>
                </div>

                {folder && (
                    <div className="flex items-center text-xs text-gray-500 hover:bg-gray-100 cursor-pointer truncate mt-1 pl-1"
                        onClick={() => {
                            onViewFolders();
                        }}
                    >
                        <span>Folder: {folder?.name}</span>
                        <img
                            src={arrowIcon}
                            alt="view folders"
                            className="w-3 h-3 ml-1 cursor-pointer"
                        />
                    </div>
                )}
            </>
        );
    };

    return (
        hasAccess ? (
            <div className="py-2 text-sm text-gray-700 px-4 gap-2">
                <h5 className="block break-words font-bold">{title}</h5>
                {renderItem()}
            </div>
        ) : null
    );
};

const ManageGlobalSelectorBox = () => {
    const { userData } = useUserContext()
    const { content } = useContentfulContext();
    const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalType, setModalType] = useState(null);
    const [showFolderModal, setShowFolderModal] = useState(false);
    const handleClick = () => {
        setIsComponentVisible(!isComponentVisible);
    };

    const handleModalOpen = (type) => {
        setIsModalOpen(true);
        setModalType(type);
    };

    const openFolderModal = (integration) => {
        setShowFolderModal(true);
    };

    const handleModalClose = () => {
        setIsModalOpen(false);
        setModalType(null);
    };

    const integrations = content?.GLOBAL_SELECTOR_CONTENT ? getIntegrations(content.GLOBAL_SELECTOR_CONTENT, userData) : []

    return (
        <div ref={ref}>
            <img
                src={setupIcon}
                alt="setup-icon"
                className="flex-shrink-0 w-8 h-8 text-gray-500 cursor-pointer"
                onClick={handleClick}
            />
            {isComponentVisible && (
                <div
                    className="bg-white divide-y py-2 divide-gray-100 rounded-lg shadow w-60 -right-8 absolute top-full z-40"
                >
                    {integrations.map((integration, index) => (
                        <IntegrationItem
                            key={index}
                            {...integration}
                            onModalOpen={() => {
                                handleClick()
                                handleModalOpen(integration.type)
                            }
                            }
                            onViewFolders={() => {
                                openFolderModal(integration);
                            }}
                        />
                    ))}
                </div>
            )}
            {isModalOpen && (
                <div>
                    {modalType === 'adobe-io-integrations' && (
                        <AdobeIoIntegrationModal handleClose={handleModalClose} />
                    )}
                    {modalType === 'contentful-integrations' && (
                        <ContentfulIntegrationModal handleClose={handleModalClose} />
                    )}
                    {modalType === 'workspaces' && (
                        <AdobeTargetWorkspaceModal handleClose={handleModalClose} />
                    )}
                    {modalType === 'tealium-api-keys' && (
                        <TealiumIntegrationModal handleClose={handleModalClose} />
                    )}
                    {modalType === 'aem-adobe-io' && (
                        <AEMAdobeIOModal handleClose={handleModalClose} />
                    )}
                    {modalType === 'github-integrations' && (
                        <GithubIntegrationModal handleClose={handleModalClose} />
                    )}
                </div>
            )}
            {showFolderModal && (
                <ViewFoldersModal
                    integration={userData?.defaultAEMAdobeIO}
                    onClose={() => setShowFolderModal(false)}
                />
            )}
        </div>
    );
};

export default ManageGlobalSelectorBox;